import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PurgeManagementComponent } from 'src/app/modules/purge/components/purge-management/purge-management.component';

declare var $: any;

@Component({
  selector: 'app-navbar',
  standalone: false,
  templateUrl: './navbar.component.html'
})
export class NavbarComponent {
  
  constructor(public dialog: MatDialog) {}

  openPurgeCacheDialog() {
    const dialogRef = this.dialog.open(PurgeManagementComponent, {
        width:"1024px",
        data:{
        } 
    });

    dialogRef.afterClosed().subscribe(result => {
      
    });
  }
}
